const HeaderAlertTypes = {
  SUCCESS: 'success', // green
  ERROR: 'error', // red
  INFO: 'info', // yellow
  INSTRUCTIONS: 'instructions', // cerulean
};

export default HeaderAlertTypes;
